export default "/images/instagram-icon.svg?b473dba8d0aa544a553a1e0bcf850ace";